export function parseContentDispositionFilename(
  header: string | null,
): string | undefined {
  if (!header) {
    return undefined;
  }
  const match = /filename="?([^";\n]+)"?/i.exec(header);
  return match?.[1]?.trim();
}

export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
